import React from "react";
import {
  Tabs,
  Tab,
  ExpansionPanelSummary,
  ExpansionPanel,
  Typography,
  ExpansionPanelDetails
} from '@material-ui/core'
import PropTypes from 'prop-types';
import { withStyles } from "@material-ui/core/styles";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import RemoveRedEye from '@material-ui/icons/RemoveRedEye'
import { CustomTooltip } from './CustomTooltip'

function TabPanel(props) {
  const { children, value, index, ...other, } = props;

  return (
    <div
      className="no_print"
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
      >
        {value === index && (
          <div p={3} style={{ borderTop: '1px solid rgba(224, 224, 224, 1)' }}>
            {children}
          </div>
        )}
    </div>
    );
  }

TabPanel.propTypes = {
children: PropTypes.node,
index: PropTypes.any.isRequired,
value: PropTypes.any.isRequired};

function setIndex(index) {
  return {
    id: `tab-${index}`,
    'aria-controls': `tabpanel-${index}`,
  };
}

const styles = theme => ({
  root:{
    color: '#393939',
    padding: '15px 2px',
    textTransform: 'capitalize',
    fontSize: 14,
    minHeight: 35,
    width: 250,
    fontWeight: 'normal',
    "@media (max-width: 960px)": {
      fontSize: 12,
      width: 'auto',
      minHeight: 25,
      '& span': {
        '& svg':{
          display: 'none',
        },
      },
    },
    '&:hover':{
      opacity:1
    },
    '& span': {
      display: 'flex',
      flexDirection: 'inherit',
      alignContent: 'space-between',
      alignItems: 'center',
      '& svg':{
        width: '.7em'
      },
      '& span':{
        width: 'auto',
        padding: 0,
        marginLeft: 5
      }
    }
  },
  selected: {
    backgroundColor: '#e2e0e7',
    color: theme.palette.primary.main,
  },
  see:{
    float: 'right',
    fontSize: 18,
    color: '#4b4b4b',
    "@media (max-width: 600px)": {
      fontSize: 12,
    },
  },
  detailSection:{
    width: '100%',
    display: 'inline',
    paddingRight: 0,
    color: theme.palette.primary.main,
    fontSize: 14,
    fontWeight: 'bold',
    marginLeft: 10,
    marginBottom: 0,
    padding: 0,
    lineHeight: 1,
    "@media (max-width: 600px)": {
      fontSize: 12,
      marginLeft: 0
    },
  },
  panel: {
    marginBottom: 20,
    "@media print": {
      display: 'none'
    }
  },
  panelDetails: {
    padding: " 0px !important",
    "@media print": {
      padding: " 0px !important",
      marginLeft: "-1.2em !important",
    }
  },
  summaryDetails: {
    backgroundColor: '#b0a4c7',
    minHeight: '42px !important',
    maxHeight: '42px !important',
    padding: 0,
    "& div":{
      margin: 0,
        right: -7
    },
    "&:before":{
      backgroundColor: 'inherit',
    },
    "@media print": {
      padding: " 0px !important",
      marginLeft: "-1.2em !important",
      marginTop: '1em',
      minHeight: '15px !important',
      borderTop: '1px solid #acacac',
      borderBottom: '1px solid #acacac',
      fontSize: '14px',
      color: theme.palette.secondary.gray,
    }
  },
  icon:{
    marginTop: 1,
    marginRight:10,
    color: theme.palette.secondary.gray,
  }
});

export class GroupedDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedTab: 0,
    };
  }

changeTab = (event, tab) => {
  this.setState({ selectedTab: tab})
}

render() {

    const { selectedTab } = this.state
    const { classes, additionalDetails, historyDetails, sent, physicalDetails } = this.props
    let optionsTabs = null;
    let tabs = null;

    //tabs
    tabs = (
      <React.Fragment>
        <TabPanel value={selectedTab} index={0}>
          {additionalDetails}
        </TabPanel>
        <TabPanel value={selectedTab} index={1}>
          {historyDetails}
        </TabPanel>
        {/* <TabPanel value={selectedTab} index={2}>
          {physicalDetails}
        </TabPanel> */}
      </React.Fragment>);

      //options
      optionsTabs = [
        <Tab key={0} label="OFICIO CON COPIA/REENVIADO A:" {...setIndex(0)}
        classes={{
          selected: classes.selected,
          root: classes.root
        }} />,
        <Tab key={1} label="HISTORIAL DE OFICIO:" {...setIndex(1)}
          classes={{
            selected: classes.selected,
            root: classes.root
          }} />,
          <Tab key={2} label="ENVIAR OFICIO EN FÍSICO A:" {...setIndex(2)}
            classes={{
              selected: classes.selected,
              root: classes.root,
            }} />]

      delete optionsTabs[2]

      let groupedSection = null;

      if(sent){
        groupedSection = (
          <ExpansionPanel className={classes.panel}>
            <ExpansionPanelSummary
              expandIcon={<React.Fragment >
                <CustomTooltip title="Ver detalles del oficio" placement="right"><ExpandMoreIcon/></CustomTooltip>
              </React.Fragment>}
              className={classes.summaryDetails}>
              <Typography variant="body1"
                align="right"
                className={classes.detailSection} gutterBottom>
                <RemoveRedEye className={classes.icon}/>
              <Typography component="span" align="right" className={classes.see}>Detalle de oficio</Typography>
              </Typography>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails style={{ display: 'block' }} className={classes.panelDetails}>
              <Tabs value={selectedTab}
                scrollButtons="on"
                onChange={this.changeTab}
                aria-label="tabs">
                {optionsTabs}
              </Tabs>
            {tabs}
          </ExpansionPanelDetails>
        </ExpansionPanel>
        );
      }

      return (groupedSection);
    }
  }

GroupedDetails.propTypes = {};
export default withStyles(styles)(GroupedDetails);



// WEBPACK FOOTER //
// ./src/components/GroupedDetails.js